import React, {useEffect,useState,useMemo} from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import getReq from '../interface/getRequestinterface';
import { getRequest } from '../request';
import { CacheProvider } from '@emotion/react';
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import { Box } from '@mui/system';
import { Rating, Typography } from '@mui/material';
import { useMediaQuery } from "react-responsive"; 
import Loading from './loading';

const style={
    formTitle:{
      fontWeight:'bold !important'
    },
    formDescription:{
      color:'#9b9b9b'
    },
    formContainer:{
      padding: '1rem !important',
      border: '3px solid #748DA6',
      backgroundColor: '#f1f7ff59',
      height:'fit-content',
      borderRadius:'0.5rem',
      width:'80%',
      marginBottom:'1rem',
      display:'flex',
      flexDirection:'column'
    },
    titleContainer:{
      padding: '1rem !important',
      border: '3px solid #f37e7b',
      backgroundColor: '#ef9a9a33',
      height:'fit-content',
      borderRadius:'0.5rem',
      width:'80%',
      marginBottom:'1rem'
    },
    container:{
      display:'flex',
      alignItems:'center',
      flexDirection:'column',
      
    },
    gridBox:{
      display:'grid',
      gridTemplateColumns:'40% 40%',
      columnGap:'5%',
      rowGap:'3%',
      justifyContent:'space-around',
      marginTop:'2rem'
    },
    mobileGridBox:{
      display:'grid',
      gridTemplateColumns:'90%',
      // columnGap:'5%',
      rowGap:'3%',
      justifyContent:'center',
      marginTop:'2rem'
    },
    modalStyle :{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      p: 4,
      backgroundColor:'#fff',
      display:'flex',
      flexDirection:'column',
      borderRadius:'3px',
      width:'30rem'
    },
    modalMobileStyle:{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      p: 4,
      backgroundColor:'#fff',
      display:'flex',
      flexDirection:'column',
      borderRadius:'3px',
      width:'15rem'
    },
    txtField:{
      width:'100%', 
    },
    headerContainer:{
      display:'flex',
      width:'100%',
      justifyContent:'space-between'
    },
    stateType:{
      fontWeight:'bold'
    },
    title:{
      display:'flex',
      justifyContent:'space-between',
      width:'65rem',
    },
    unShown:{
      visibility:'none'
    }
  }

  interface QuestionString{
    question:string;
    answer:number;
    questionId:number;
  }
  interface QuestionList{
    pollformName:string;
    pollformId:number;
    filled:boolean;
    description:string;
    questions:QuestionString[];
  }

function ShowFilledForms() {
    const params = useParams();
    const location = useLocation();
    const [questionList, setQuestionList] = useState<QuestionList>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const cacheRtl = useMemo(() => {
      return createCache({
        key: "muirtl",
        stylisPlugins: [prefixer, rtlPlugin]
      });
    }, []);

    const getFilledAnswers=async()=>{
        const {data,error}:getReq = await getRequest(`${process.env.REACT_APP_BASE_URL}/Poll/ShowfilledPollforms/${params.pollformId}`) as getReq;
        if(!error){
            setQuestionList(data.map(x=>({
                pollformName:x.pollformName,
                pollformId:x.pollformId,
                filled:x.filled,
                description:x.description,
                questions:x.questions.map(q=>({question:q.question,questionId:q.questionId,answer:q.answer}))
              })));
              setTimeout(() => {
                setIsLoading(true);
              }, 1500);
        }else{
            toast.error(error);
        }
    }
    useEffect(() => {
      setQuestionList(location.state.map(x=>({
        pollformName:x.pollformName,
        pollformId:x.pollformId,
        filled:x.filled,
        description:x.description,
        questions:x.questions.map(q=>({question:q.question,questionId:q.questionId,answer:q.answer}))
      })));
      setTimeout(() => {
        setIsLoading(true)
      }, 1500);
    }, []);

    const isDesktop = useMediaQuery({
        query: "(min-width: 1224px)"
      });
      
      const isTablet = useMediaQuery({
        query: "(max-width: 768px)"
      });
      
      const isMobile = useMediaQuery({
        query: "(max-width: 400px)"
      });
    
  return (
    <CacheProvider value={cacheRtl}>
        {isLoading?
        <div className='background'>
        <Box sx={style.container}>
            <Box sx={isDesktop?
                    {height:'4rem',display:'flex',alignItems:'center',width:'80%'}:
                    isMobile?
                    {height:'4rem',display:'flex',alignItems:'center',width:'80%',marginBottom:'3rem',marginTop:'2.5rem'}:
                    {height:'4rem',display:'flex',alignItems:'center',width:'80%'}
                  }
              >
              <Typography variant="h5" sx={{fontWeight:'bold'}}>
                {questionList[0]?.pollformName}
              </Typography>
            </Box>
            <Box sx={style.titleContainer} >
                <Typography variant="body1" sx={{fontWeight:'bold'}}>توضیحات کاربر:</Typography>
                <Typography variant="body1" >
                    {
                        questionList[0]?.description
                    }
                </Typography>
            </Box>
            {
              questionList[0]?.questions?.map((q,idx)=>
                <Box key={idx} sx={style.formContainer} >
                    <Typography gutterBottom>{q.question}</Typography>
                    <Box
                      sx={{
                        height:'3rem',
                        display:'flex'
                      }}>
                        <Typography variant="body1">امتیاز:</Typography>
                        <Rating
                          value={q.answer}
                        />
                        <Typography sx={{fontWeight:'bold',marginLeft:'1rem'}}>{q.answer}</Typography>
                    </Box>
                </Box>
                )
            }
          </Box>
        </div>
          :
          <div style={{width:'100vw',height:'calc( 100vh - 64px)',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <Loading type="cylon" color="#000"/>
          </div>
          }
    </CacheProvider>
  )
}

export default ShowFilledForms
